import React from 'react';
import styles from './OverviewCards.module.css';

export default function OverviewCards({ data }) {
    const cards = [
        { title: 'إجمالي الاحتجاجات', value: data.all_time, sub: null },
        {
            title: 'آخر 30 يوم',
            value: data.last_30_days.count,
            sub: `${data.last_30_days.growth > 0 ? '+' : ''}${data.last_30_days.growth}%`,
            trend: data.last_30_days.growth > 0 ? 'up' : data.last_30_days.growth < 0 ? 'down' : null,
        },
        {
            title: 'آخر 7 أيام',
            value: data.last_7_days.count,
            sub: `${data.last_7_days.growth > 0 ? '+' : ''}${data.last_7_days.growth}%`,
            trend: data.last_7_days.growth > 0 ? 'up' : data.last_7_days.growth < 0 ? 'down' : null,
        },
        { title: 'محافظات نشطة', value: `${data.active_governorates} / ${data.total_governorates}`, sub: null },
        { title: 'متوسط المشاركين', value: data.avg_participants.toLocaleString('ar'), sub: null },
    ];

    return (
        <div className={styles.grid}>
            {cards.map((card, idx) => (
                <div key={idx} className={`${styles.card} ${card.trend ? styles[card.trend] : ''}`}>
                    <p className={styles.title}>{card.title}</p>
                    <p className={styles.value}>{card.value}</p>
                    {card.sub && (
                        <p className={`${styles.sub} ${card.trend ? styles[`sub_${card.trend}`] : ''}`}>
                            {card.trend === 'up' ? '↑' : card.trend === 'down' ? '↓' : ''} {card.sub}
                        </p>
                    )}
                </div>
            ))}
        </div>
    );
}
